<template>
  <article
    class="gh-card gh-card--design gh-card--design-board"
    :class="{ 'gh-card--collapsed': collapsed }"
  >
    <slot name="context-head" />
    <div class="gh-card-design__row">
      <button type="button" class="gh-card__chevron" @click="$emit('toggle-collapse')">
        <i
          :class="collapsed ? 'fa fa-chevron-up' : 'fa fa-chevron-down' "
          aria-hidden="true"
        ></i>
      </button>
      <div class="gh-card-design__image">
        <img
          v-if="card.output.url"
          ref="cardImage"
          :src="card.output.url"
          class="gh-card__image"
          :class="{ 'gh-dnd-source': canDrag }"
          alt=""
          :draggable="canDrag"
          @dragstart="onImageDragStart"
          @dragend="onDragEnd"
        >
      </div>
      <div class="gh-card-design__prompt-col">
        <GenerationHistoryCardSlide :expanded="!collapsed">
          <div class="gh-card-design__prompt">
            <div class="gh-card-text__meta gh-card-text__meta--in-design">
              <GenerationHistoryMetaRows
                :fields="metaFields"
                variant="detail"
                :can-drag-fields="canDrag"
                :drag-field-keys="missionDragKeys"
                :row-key-prefix="`design-board-${card.item_id}`"
                @field-drag-start="onMissionDragStart"
                @field-drag-end="onDragEnd"
              />
            </div>
          </div>
        </GenerationHistoryCardSlide>
      </div>
      <div class="gh-card-design__actions-col">
        <GenerationHistoryDesignCardActions
          :is-favorite="card.is_favorite"
          :is-image-copied="isImageCopied"
          :is-copied="isCopied"
          :show-copy="true"
          :show-copy-prompt="false"
          @copy-image="$emit('copy-image', $refs.cardImage)"
          @copy="$emit('copy')"
          @download="$emit('download')"
          @favorite="$emit('favorite')"
        />
      </div>
    </div>
  </article>
</template>

<script>
import { getDesignBoardDetailMetaFields } from '@/shared/helpers/generationHistory';
import { GH_DRAG_SOURCE } from '@/shared/helpers/generationHistoryDrag';
import { GH_TEXT_FIELD } from '@/shared/helpers/generationHistoryAssistDrag';
import { generationHistoryCardDragMixin } from '@/shared/mixins/generationHistoryDragDropMixin';
import GenerationHistoryCardSlide from '../shared/GenerationHistoryCardSlide.vue';
import GenerationHistoryDesignCardActions from '../shared/GenerationHistoryDesignCardActions.vue';
import GenerationHistoryMetaRows from '../shared/GenerationHistoryMetaRows.vue';

export default {
  name: 'GenerationHistoryDetailCardDesignBoard',
  mixins: [generationHistoryCardDragMixin],
  components: {
    GenerationHistoryCardSlide,
    GenerationHistoryDesignCardActions,
    GenerationHistoryMetaRows,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    projectType: {
      type: Number,
      required: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    isCopied: {
      type: Boolean,
      default: false,
    },
    isImageCopied: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      missionDragKeys: [GH_TEXT_FIELD.MISSION],
    };
  },
  computed: {
    metaFields() {
      return getDesignBoardDetailMetaFields(this.card, this.projectType, this.$t.bind(this));
    },
  },
  methods: {
    onMissionDragStart(event, field) {
      this.startGhTextDrag(event, {
        text: field && field.value,
        sourceType: GH_DRAG_SOURCE.DESIGN,
        itemId: this.card.item_id,
        field: GH_TEXT_FIELD.MISSION,
      });
    },
    onImageDragStart(event) {
      this.startGhImageDrag(event, {
        url: (this.card.output && this.card.output.url) || '',
        itemId: this.card.item_id,
        itemType: this.card.item_type,
        posterIndex: 0,
        sourceType: GH_DRAG_SOURCE.DESIGN,
      });
    },
  },
};
</script>
